export default "__VITE_ASSET__CflTZyPW__"